import React, { useState, useEffect } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { CloudinaryResource, fetchImagesByTag, getThumbnailUrl, getFullSizeUrl } from '../utils/cloudinary';

const Travel: React.FC = () => {
  const [travelImages, setTravelImages] = useState<CloudinaryResource[]>([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState<string[]>([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    fetchImagesByTag('travel', 150).then(setTravelImages);
  }, []);

  const openLightbox = (images: string[], index: number) => {
    setLightboxImages(images);
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <div className="text-justify">
        <br />
        <h3>Travel</h3>
        <br />
        <p>In June 2018, I set off on a sabbatical break to travel, backpack in Europe and South America, and learn to fly small airplanes.</p>
        <p>Through those travels I visited India, Spain, France, Italy, Portugal, Brazil, Chile, Argentina, Colombia, Canada, China, Indonesia, Hong Kong, and the US (and travelled more than 105,000 miles!)</p>
        <p>These are some photos I took along the way.</p>
      </div>

      <br />

      <div className="row">
        <style>{`
          div.imagetiles div.col-lg-3.col-md-3.col-sm-3.col-xs-6 {
            padding: 10px;
          }
        `}</style>

        <div className="col-md-12">
          <div className="container">
            <div className="row imagetiles">
              {travelImages.map((image, index) => (
                <div key={image.public_id} className="col-lg-3 col-md-3 col-sm-3 col-xs-6" id="links">
                  <a
                    href={getFullSizeUrl(image.public_id)}
                    data-lightbox="gallery"
                    onClick={(e) => {
                      e.preventDefault();
                      const allImages = travelImages.map(img => getFullSizeUrl(img.public_id));
                      openLightbox(allImages, index);
                    }}
                  >
                    <img
                      src={getThumbnailUrl(image.public_id)}
                      alt={`Travel ${index + 1}`}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={lightboxImages.map(src => ({ src }))}
        index={lightboxIndex}
      />
    </>
  );
};

export default Travel;
